import Button from '../../../components/Button';

type TabType = 'details' | 'pages';

interface LessonFormTabsProps {
    activeTab: TabType;
    onTabChange: (tab: TabType) => void;
    pagesCount: number;
}

interface TabConfig {
    id: TabType;
    label: string;
}

export default function LessonFormTabs({ activeTab, onTabChange, pagesCount }: LessonFormTabsProps) {
    const tabs: TabConfig[] = [
        { id: 'details', label: 'Lesson Details' },
        { id: 'pages', label: `Content Pages (${pagesCount})` },
    ];

    const getTabClassName = (tabId: TabType): string => {
        const isActive = activeTab === tabId;
        const baseClasses = 'py-2 px-4 font-medium text-sm outline-none';
        const activeClasses = 'bg-blue-100 text-blue-900';
        const inactiveClasses = 'text-gray-600 hover:bg-gray-100 hover:text-gray-900';

        return `${baseClasses} ${isActive ? activeClasses : inactiveClasses}`;
    };

    return (
        <nav className="flex flex-wrap gap-2 px-4 sm:px-6 border-b border-gray-200" role="tablist">
            {tabs.map((tab) => (
                <Button
                    key={tab.id}
                    onClick={() => onTabChange(tab.id)}
                    variant="ghost"
                    className={getTabClassName(tab.id)}
                    role="tab"
                    aria-selected={activeTab === tab.id}
                    aria-controls={`${tab.id}-panel`}
                >
                    {tab.label}
                </Button>
            ))}
        </nav>
    );
} 